import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { PHONE, PHONE_HREF } from "@/components/Nav";

const regions = [
  {
    state: "South Coast & Attleboro Area — MA",
    towns: "Attleboro · North Attleborough · Fall River · New Bedford · Taunton · Seekonk · Swansea · Somerset · Rehoboth · Dartmouth · Westport · Fairhaven · Acushnet · Dighton · Berkley · Raynham · Norton · Mansfield · Easton · Foxborough · Plainville · Wrentham · Middleborough · Lakeville · Wareham",
  },
  {
    state: "Greater Boston & MetroWest — MA",
    towns: "Boston · Cambridge · Somerville · Quincy · Braintree · Weymouth · Newton · Waltham · Brookline · Dedham · Needham · Wellesley · Natick · Framingham · Milton · Randolph · Canton · Norwood · Walpole · Stoughton · Brockton · Abington · Whitman · Hanover · Pembroke · Plymouth",
  },
  {
    state: "Worcester County & 495 Belt — MA",
    towns: "Worcester · Shrewsbury · Auburn · Millbury · Grafton · Northborough · Westborough · Southborough · Marlborough · Hopkinton · Milford · Franklin · Bellingham · Medway · Holliston · Ashland · Uxbridge · Blackstone · Millville · Hopedale",
  },
  {
    state: "North Shore & Merrimack Valley — MA",
    towns: "Lynn · Peabody · Salem · Beverly · Danvers · Andover · Lowell · Lawrence",
  },
  {
    state: "Cape Cod — MA",
    towns: "Bourne · Sandwich · Mashpee · Falmouth · Barnstable · Hyannis · Yarmouth · Dennis",
  },
  {
    state: "Rhode Island — Every City & Town",
    towns: "Providence · Cranston · Warwick · Pawtucket · East Providence · Woonsocket · Cumberland · Lincoln · Smithfield · Johnston · North Providence · Central Falls · Coventry · West Warwick · East Greenwich · Scituate · Glocester · Burrillville · Foster · Bristol · Warren · Barrington · Tiverton · Little Compton · Portsmouth · Middletown · Newport · Jamestown · North Kingstown · South Kingstown · Narragansett · Exeter · Richmond · Hopkinton · Charlestown · Westerly",
  },
];

export default function ServiceArea() {
  return (
    <section className="border-t border-navy/15 bg-ice px-5 py-14 sm:px-10 lg:py-20 xl:px-16" data-testid="service-area-section">
      <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="mb-2 font-mono2 text-[10px] uppercase tracking-[0.35em] text-royal">Service area</p>
          <h2 className="font-display text-4xl uppercase leading-none text-navy sm:text-5xl">
            Where we run.
          </h2>
        </div>
        <p className="flex max-w-xs items-center gap-2 text-sm text-navy/60">
          <MapPin className="h-4 w-4 shrink-0 text-royal" strokeWidth={2.5} />
          Based in Attleboro — from Boston to the Cape, Worcester to Westerly, and every town between.
        </p>
      </div>
      <div className="grid grid-cols-1 gap-px border border-navy/20 bg-navy/20 sm:grid-cols-2 lg:grid-cols-3">
        {regions.map((r, i) => (
          <motion.div
            key={r.state}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: (i % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
            className="bg-white p-5"
            data-testid={`service-area-region-${i}`}
          >
            <h3 className="mb-2 font-display text-base uppercase tracking-wide text-navy">{r.state}</h3>
            <p className="font-mono2 text-[10px] uppercase leading-relaxed tracking-[0.1em] text-navy/55">
              {r.towns}
            </p>
          </motion.div>
        ))}
      </div>
      <p className="mt-6 font-mono2 text-[10px] uppercase tracking-[0.25em] text-navy/50">
        Don't see your town? Call <a href={PHONE_HREF} className="text-royal underline" data-testid="service-area-call-link">{PHONE}</a> — if you're in the area, we'll get to you.
      </p>
    </section>
  );
}
